import defaultPostTypeConfig from '../post'
import capitalize from '../../utils/capitalize'

export default function getConstants(p = {}) {

    const name = 'profession'

    const n = name
    const N = capitalize(n)
    const ns = (name.endsWith('y')) ? name.slice(0, -1) + 'ies' : name + 's'
    const Ns = capitalize(ns)

    const {
        labels,
        menus,
        messages,
        routes,
        titles
    } = defaultPostTypeConfig.getConstants({
        ...p,
        name
    })

    return {
        labels: {
            ...labels,
            ['new' + N + 'SubmitLabel']: 'Mentés',
            ['restore' + N + 'SubmitLabel']: 'Visszaállítás',
            ['save' + N + 'SubmitLabel']: 'Mentés',
            ['cancel' + N + 'Text']: 'Mégsem',
            ['delete' + N + 'Text']: 'Törlés',
            ['delete' + Ns + 'Text']: 'Szakmák törlése',
            ['ban' + N + 'Text']: 'Tiltás',
            ['approve' + N + 'Text']: 'Jóváhagyás',
            ['protection' + N + 'Text']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Text']: 'Védettség megszüntetése',
            ['select' + N + 'Text']: 'Kiválasztás',
            ['add' + N + 'Text']: 'Hozzáadás',
            ['date' + N + 'Format']: ({ dateText = '' }) => {
                if (!dateText) {
                    return dateText
                }
                try {
                    return new Date(dateText).toLocaleString('hu-HU')
                } catch (e) {
                }
                return dateText
            },
            [ns + 'SortRelevance']: 'Relevancia',
            [ns + 'More']: 'Továbbiak'
        },
        menus: {
            ...menus,
            ['user' + Ns + 'Menu']: 'Szakmák',
            ['my' + Ns + 'Menu']: 'Szakmáim',
            ['new' + N + 'Menu']: 'Új szakma',
            [ns + 'Menu']: 'Szakmák',
            ['deleted' + Ns + 'Menu']: 'Törölt szakmák',
            ['banned' + Ns + 'Menu']: 'Véglegesen törölt szakmák',
            ['protection' + Ns + 'Menu']: 'Védett szakmák',
            ['missingData' + Ns + 'Menu']: 'Hiányzó adatok',
            ['lowAuthorStatus' + Ns + 'Menu']: 'Szerző alacsony státusszal',

            ['edit' + N + 'Menu']: 'Szerkesztés',
            ['delete' + N + 'Menu']: 'Törlés',
            ['ban' + N + 'Menu']: 'Tiltás',
            ['approve' + N + 'Menu']: 'Jóváhagyás',
            ['protection' + N + 'Menu']: 'Védettnek jelölés',
            ['removeProtection' + N + 'Menu']: 'Védettség törlése'
        },
        messages: {
            ...messages,
            ['new' + N + 'SuccessMessage']: 'Az új szakma mentésre került',
            ['save' + N + 'SuccessMessage']: 'A szakma mentésre került',
            ['delete' + N + 'Success']: 'A szakma törölve lett',
            ['delete' + Ns + 'Success']: 'A szakmák törölve lettek',
            ['delete' + N + 'Question']: 'Biztosan törli a szakmát?',
            ['delete' + Ns + 'Question']: 'Biztosan törli a szakmákat?',
            ['ban' + N + 'Success']: 'A szakma véglegesen törölve lett',
            ['ban' + N + 'Question']: 'Biztos, hogy a szakmát véglegesen törölni akarod?',
            ['approve' + N + 'Success']: 'A szakma jóvá lett hagyva',
            ['approve' + N + 'Question']: 'Biztosan jóváhagyod a szakmát',
            ['protection' + N + 'Success']: 'A szakma védettnek jelölve',
            ['protection' + N + 'Question']: 'Biztosan védettnek jelölöd a szakmát?',
            ['removeProtection' + N + 'Success']: 'A védettnek jelölés törölve lett',
            ['removeProtection' + N + 'Question']: 'Biztosan törlöd a védettnek jelölést?',
            ['thereAreNo' + Ns]: 'Nincsenek szakmák'
        },
        routes: {
            ...routes
        },
        titles: {
            ...titles,
            [n + 'Title']: 'Szakma',
            [ns + 'Title']: 'Szakmák',
            ['new' + N + 'Title']: 'Új szakma',
            ['edit' + N + 'Title']: 'Szakma szerkesztése',
            ['user' + Ns + 'Title']: 'Szakmák',
            ['userDeleted' + Ns + 'Title']: 'Törölt szakmák',
            ['my' + Ns + 'Title']: 'Szakmáim',
            ['myDeleted' + Ns + 'Title']: 'Törölt szakmáim',

            ['dialogDelete' + N + 'Title']: 'Szakma törlése',
            ['dialogBan' + N + 'Title']: 'Szakma törlése véglegesen',
            ['dialogApprove' + N + 'Title']: 'Szakma jóváhagyása',
            ['dialogProtection' + N + 'Title']: 'Szakma védettnek jelölése',
            ['dialogRemoveProtection' + N + 'Title']: 'Szakma védettségének megszüntetése',

            ['dialogDelete' + Ns + 'Title']: 'Szakmák törlése',

            ['statusBanned' + N + 'Title']: 'Véglegesen törölt',
            ['statusDeleted' + N + 'Title']: 'Törölt',
            ['statusAuthorDeleted' + N + 'Title']: 'Szerző törölve',
            ['statusMissingData' + N + 'Title']: 'Hiányzó adatok',
            ['statusApproved' + N + 'Title']: 'Jóváhagyott',
            ['statusFeatured' + N + 'Title']: 'Védett',
            ['statusCreated' + N + 'Title']: 'Létrehozva',

            ['banned' + Ns + 'Title']: 'Véglegesen törölt szakmák',
            ['deleted' + Ns + 'Title']: 'Törölt szakmák',
            ['missingData' + Ns + 'Title']: 'Hiányzó adatok',
            ['protected' + Ns + 'Title']: 'Védett szakmák',
            ['lowAuthorStatus' + Ns + 'Title']: 'Szerző alacsony státusszal',

            ['select' + Ns]: 'Szakmák kiválasztása',
            ['select' + N]: 'Szakma kiválasztása'
        }
    }
}
